import { render, staticRenderFns } from "./Evaluations.vue?vue&type=template&id=1b50076d"
import script from "./Evaluations.vue?vue&type=script&lang=js"
export * from "./Evaluations.vue?vue&type=script&lang=js"
import style0 from "./Evaluations.vue?vue&type=style&index=0&id=1b50076d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports